import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar'
import Icon from '@space-core/components/icon'
import LineClamp from '@space-core/components/lineClamp'
import { useMediaQuery } from '@space-core/hooks'
import useTranslation from '@space-core/hooks/useTranslation'
import { ScreenSizes } from '@space-core/styles'
import clsx from 'clsx'

import { AccessButton } from './components/accessButton'
import { AccessCall } from './components/accessCall'
import { Cover } from './components/cover'

import { useSessionsDate } from '../../hooks/useSessionsDate'

export type SessionCardProps = {
  calendarExternalName: string
  utcStartAt: string
  utcEndAt: string
  link: string
  className?: string
  calendarExternalThumbnail?: string
  productName?: string
}

const SessionCard = ({
  calendarExternalName,
  calendarExternalThumbnail,
  utcStartAt,
  utcEndAt,
  link,
  productName,
  className
}: SessionCardProps) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)

  const {
    isSessionInProgress,
    dateSessionFormat,
    hourInitSession,
    hourEndSession,
    durationSeconds
  } = useSessionsDate({ utcStartAt, utcEndAt })

  return (
    <div
      data-test='session-card'
      className={clsx(
        '_d-md-flex _align-items-md-center _p-4 _bg-gray-100 _border-gray-300 _border _rounded-lg _mt-3 _mr-3',
        className
      )}>
      <div className='_d-flex _justify-content-between _align-items-start'>
        <Cover pictureUrl={calendarExternalThumbnail} />

        {isMobile && <AccessButton link={link} isSessionInProgress={isSessionInProgress} />}
      </div>
      <div className='_d-flex _flex-column _mt-4 _mt-md-0'>
        <LineClamp className='_text-gray-900 _text-2 _font-weight-bold'>
          {calendarExternalName}
        </LineClamp>
        <span className='_text-gray-600 _text-1 _mb-2'>
          {productName ? (
            <LineClamp>{productName}</LineClamp>
          ) : (
            <>
              <Icon aria-hidden className='_mr-2' icon={faCalendar} />
              {t('mentorship.session_card.full_date', {
                dateSession: dateSessionFormat,
                hourInitSession: hourInitSession,
                hourEndSession: hourEndSession
              })}
              h
            </>
          )}
        </span>

        <div className='_d-flex _align-items-center'>
          {!isMobile && <AccessButton link={link} isSessionInProgress={isSessionInProgress} />}
          <AccessCall durationSeconds={durationSeconds} isSessionInProgress={isSessionInProgress} />
        </div>
      </div>
    </div>
  )
}

export default SessionCard
